import * as React from 'react';
import './base/styles/main.css';
import { Provider } from 'react-redux';
import Router from './base/routers/Router';
import store from './base/stores/store';

export default (props: {}) => {
    return (
        <Provider store={store}>
            <Router />
        </Provider>
    );
};
